(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["expected-deliver-4"] && !Shopify.designMode) return;
  try {
    
(function() {
  var instances = new WeakMap();

  function getRoot(section) {
    if (!section) return null;

    if (
      section.classList &&
      section.classList.contains('sc-ed-root')
    ) {
      return section;
    }

    if (section.querySelector) {
      return section.querySelector('.sc-ed-root');
    }

    return null;
  }

  function cleanup(root) {
    var state = instances.get(root);

    if (!state) return;

    if (state.observer) {
      state.observer.disconnect();
      state.observer = null;
    }

    if (state.timers && state.timers.length) {
      state.timers.forEach(function(timer) {
        clearTimeout(timer);
      });

      state.timers = [];
    }

    if (state.countdownInterval) {
      clearInterval(state.countdownInterval);
      state.countdownInterval = null;
    }

    instances.delete(root);
  }

  function activateAll(root, state) {
    var track = root.querySelector(
      '[data-track-fill]'
    );

    var stage2 = root.querySelector(
      '[data-stage="2"]'
    );

    var stage3 = root.querySelector(
      '[data-stage="3"]'
    );

    var icon2 = root.querySelector(
      '[data-icon-stage="2"]'
    );

    var icon3 = root.querySelector(
      '[data-icon-stage="3"]'
    );

    if (track) {
      track.style.transition = 'none';
      track.style.width = '100%';
    }

    if (stage2) {
      stage2.classList.add('is-active');
    }

    if (stage3) {
      stage3.classList.add('is-active');
    }

    if (icon2) {
      icon2.classList.add('is-active');
    }

    if (icon3) {
      icon3.classList.add('is-active');
    }

    state.animationStarted = true;
  }

  function runAnimation(root, state) {
    var track = root.querySelector(
      '[data-track-fill]'
    );

    var stage2 = root.querySelector(
      '[data-stage="2"]'
    );

    var stage3 = root.querySelector(
      '[data-stage="3"]'
    );

    var icon2 = root.querySelector(
      '[data-icon-stage="2"]'
    );

    var icon3 = root.querySelector(
      '[data-icon-stage="3"]'
    );

    if (!track || !stage2 || !stage3) {
      return;
    }

    var speed = Math.max(
      0.5,
      parseFloat(
        root.dataset.animationSpeed || '3'
      )
    );

    var delay = Math.max(
      0,
      parseFloat(
        root.dataset.animationDelay || '0'
      )
    );

    var halfDuration =
      (speed * 1000) / 2;

    track.style.transition = 'none';
    track.style.width = '0%';

    stage2.classList.remove('is-active');
    stage3.classList.remove('is-active');

    if (icon2) {
      icon2.classList.remove('is-active');
    }

    if (icon3) {
      icon3.classList.remove('is-active');
    }

    void track.offsetWidth;

    var delayTimer = setTimeout(function() {

      track.style.transition =
        'width ' +
        halfDuration +
        'ms cubic-bezier(.22,.61,.36,1)';

      requestAnimationFrame(function() {
        track.style.width = '50%';
      });

      var stage2Timer = setTimeout(function() {

        stage2.classList.add('is-active');

        if (icon2) {
          icon2.classList.add('is-active');
        }

        track.style.transition =
          'width ' +
          halfDuration +
          'ms cubic-bezier(.22,.61,.36,1)';

        requestAnimationFrame(function() {
          track.style.width = '100%';
        });

        var stage3Timer = setTimeout(function() {

          stage3.classList.add('is-active');

          if (icon3) {
            icon3.classList.add('is-active');
          }

        }, halfDuration);

        state.timers.push(stage3Timer);

      }, halfDuration);

      state.timers.push(stage2Timer);

    }, delay);

    state.timers.push(delayTimer);
  }

  function setupAnimation(root, state) {
    if (state.animationStarted) {
      return;
    }

    var timeline = root.querySelector(
      '[data-timeline]'
    );

    if (!timeline) {
      return;
    }

    var enabled =
      root.dataset.animationEnabled === 'true';

    if (!enabled) {
      activateAll(root, state);
      return;
    }

    /*
      IMPORTANT:
      Do not run animation immediately
      on page load.

      Wait for the actual timeline to
      enter the viewport.
    */

    if (!('IntersectionObserver' in window)) {
      state.animationStarted = true;
      runAnimation(root, state);
      return;
    }

    state.observer =
      new IntersectionObserver(
        function(entries) {

          for (
            var i = 0;
            i < entries.length;
            i++
          ) {
            var entry = entries[i];

            if (
              entry.isIntersecting &&
              !state.animationStarted
            ) {
              state.animationStarted = true;

              if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
              }

              runAnimation(root, state);

              break;
            }
          }

        },
        {
          threshold: 0.20,
          root: null,
          rootMargin: '0px'
        }
      );

    state.observer.observe(timeline);
  }

  function setupCountdown(root, state) {
    if (
      root.dataset.countdownEnabled !== 'true'
    ) {
      return;
    }

    var output = root.querySelector(
      '[data-countdown]'
    );

    if (!output) {
      return;
    }

    var minutes = Math.max(
      1,
      parseInt(
        root.dataset.countdownMinutes || '10',
        10
      )
    );

    var storageKey =
      root.dataset.countdownKey;

    if (!storageKey) {
      return;
    }

    var endTime = null;

    try {
      var saved =
        window.sessionStorage.getItem(
          storageKey
        );

      if (saved) {
        var parsed =
          parseInt(saved, 10);

        if (
          parsed &&
          parsed > Date.now()
        ) {
          endTime = parsed;
        }
      }
    } catch (error) {
      endTime = null;
    }

    if (!endTime) {
      endTime =
        Date.now() +
        (minutes * 60 * 1000);

      try {
        window.sessionStorage.setItem(
          storageKey,
          String(endTime)
        );
      } catch (error) {}
    }

    function update() {
      var remaining =
        Math.max(
          0,
          endTime - Date.now()
        );

      var totalSeconds =
        Math.floor(
          remaining / 1000
        );

      var mins =
        Math.floor(
          totalSeconds / 60
        );

      var secs =
        totalSeconds % 60;

      output.textContent =
        String(mins).padStart(2, '0') +
        ':' +
        String(secs).padStart(2, '0');

      if (remaining <= 0) {
        clearInterval(
          state.countdownInterval
        );

        state.countdownInterval = null;
      }
    }

    update();

    state.countdownInterval =
      setInterval(
        update,
        1000
      );
  }

  function init(root) {
    if (!root || instances.has(root)) {
      return;
    }

    var state = {
      observer: null,
      countdownInterval: null,
      timers: [],
      animationStarted: false
    };

    instances.set(root, state);

    setupAnimation(root, state);
    setupCountdown(root, state);
  }

  function initAll(scope) {
    var roots = [];

    if (scope) {
      var direct = getRoot(scope);

      if (direct) {
        roots.push(direct);
      }

      if (scope.querySelectorAll) {
        scope
          .querySelectorAll('.sc-ed-root')
          .forEach(function(root) {

            if (
              roots.indexOf(root) === -1
            ) {
              roots.push(root);
            }

          });
      }
    } else {
      document
        .querySelectorAll('.sc-ed-root')
        .forEach(function(root) {
          roots.push(root);
        });
    }

    roots.forEach(function(root) {
      init(root);
    });
  }

  function unloadSection(section) {
    var root = getRoot(section);

    if (root) {
      cleanup(root);
    }
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function() {
        initAll(document);
      }
    );
  } else {
    initAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function(event) {
      initAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function(event) {
      unloadSection(event.target);
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expected-delivery2"] && !Shopify.designMode) return;
  try {
    
(function() {
  var instances = new WeakMap();

  function getRoot(section) {
    if (!section) return null;
    if (section.classList && section.classList.contains('sc-ed-root')) return section;
    return section.querySelector ? section.querySelector('.sc-ed-root') : null;
  }

  function cleanup(root) {
    var state = instances.get(root);
    if (!state) return;

    if (state.observer) {
      state.observer.disconnect();
      state.observer = null;
    }

    if (state.timers && state.timers.length) {
      state.timers.forEach(function(timer) {
        clearTimeout(timer);
      });
      state.timers = [];
    }

    if (state.countdownInterval) {
      clearInterval(state.countdownInterval);
      state.countdownInterval = null;
    }

    instances.delete(root);
  }

  function activateAll(root, state) {
    var track = root.querySelector('[data-track-fill]');
    var stage2 = root.querySelector('[data-stage="2"]');
    var stage3 = root.querySelector('[data-stage="3"]');

    if (track) track.style.width = '100%';
    if (stage2) stage2.classList.add('is-active');
    if (stage3) stage3.classList.add('is-active');

    state.animationStarted = true;
  }

  function runAnimation(root, state) {
    var track = root.querySelector('[data-track-fill]');
    var stage2 = root.querySelector('[data-stage="2"]');
    var stage3 = root.querySelector('[data-stage="3"]');

    if (!track || !stage2 || !stage3) return;

    var speed = Math.max(1, parseFloat(root.dataset.animationSpeed || '3'));
    var delay = Math.max(0, parseFloat(root.dataset.animationDelay || '0'));
    var halfDuration = (speed * 1000) / 2;

    track.style.transition = 'none';
    track.style.width = '0%';
    stage2.classList.remove('is-active');
    stage3.classList.remove('is-active');

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        var delayTimer = setTimeout(function() {
          track.style.transition =
            'width ' + halfDuration + 'ms cubic-bezier(.22,.61,.36,1)';

          requestAnimationFrame(function() {
            track.style.width = '50%';
          });

          var stage2Timer = setTimeout(function() {
            stage2.classList.add('is-active');

            track.style.transition =
              'width ' + halfDuration + 'ms cubic-bezier(.22,.61,.36,1)';

            requestAnimationFrame(function() {
              track.style.width = '100%';
            });

            var stage3Timer = setTimeout(function() {
              stage3.classList.add('is-active');
            }, halfDuration);

            state.timers.push(stage3Timer);
          }, halfDuration);

          state.timers.push(stage2Timer);
        }, delay);

        state.timers.push(delayTimer);
      });
    });
  }

  function setupAnimation(root, state) {
    if (state.animationStarted) return;

    var timeline = root.querySelector('[data-timeline]');
    if (!timeline) return;

    var enabled = root.dataset.animationEnabled === 'true';

    if (!enabled) {
      activateAll(root, state);
      return;
    }

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      activateAll(root, state);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      activateAll(root, state);
      return;
    }

    state.observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !state.animationStarted) {
          state.animationStarted = true;
          state.observer.disconnect();
          state.observer = null;
          runAnimation(root, state);
        }
      });
    }, {
      threshold: 0.25
    });

    state.observer.observe(root);
  }

  function setupCountdown(root, state) {
    if (root.dataset.countdownEnabled !== 'true') return;

    var output = root.querySelector('[data-countdown]');
    if (!output) return;

    var minutes = Math.max(
      1,
      parseInt(root.dataset.countdownMinutes || '10', 10)
    );

    var storageKey = root.dataset.countdownKey;
    if (!storageKey) return;

    var endTime = null;

    try {
      var saved = window.sessionStorage.getItem(storageKey);

      if (saved) {
        var parsed = parseInt(saved, 10);

        if (parsed > Date.now()) {
          endTime = parsed;
        }
      }
    } catch (error) {
      endTime = null;
    }

    if (!endTime) {
      endTime = Date.now() + (minutes * 60 * 1000);

      try {
        window.sessionStorage.setItem(storageKey, String(endTime));
      } catch (error) {}
    }

    var update = function() {
      var remaining = Math.max(0, endTime - Date.now());
      var totalSeconds = Math.floor(remaining / 1000);
      var mins = Math.floor(totalSeconds / 60);
      var secs = totalSeconds % 60;

      output.textContent =
        String(mins).padStart(2, '0') +
        ':' +
        String(secs).padStart(2, '0');

      if (remaining <= 0) {
        clearInterval(state.countdownInterval);
        state.countdownInterval = null;
      }
    };

    update();
    state.countdownInterval = setInterval(update, 1000);
  }

  function init(root) {
    if (!root || instances.has(root)) return;

    var state = {
      observer: null,
      countdownInterval: null,
      timers: [],
      animationStarted: false
    };

    instances.set(root, state);

    setupAnimation(root, state);
    setupCountdown(root, state);
  }

  function initAll(scope) {
    var roots = [];

    if (scope) {
      var direct = getRoot(scope);
      if (direct) roots.push(direct);

      if (scope.querySelectorAll) {
        scope.querySelectorAll('.sc-ed-root').forEach(function(root) {
          if (roots.indexOf(root) === -1) roots.push(root);
        });
      }
    } else {
      document.querySelectorAll('.sc-ed-root').forEach(function(root) {
        roots.push(root);
      });
    }

    roots.forEach(init);
  }

  function unloadSection(section) {
    if (!section) return;

    var root = getRoot(section);
    if (root) cleanup(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    unloadSection(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expected-delivery3"] && !Shopify.designMode) return;
  try {
    
(function() {
  var instances = new WeakMap();

  function getRoot(section) {
    if (!section) return null;

    if (
      section.classList &&
      section.classList.contains('sc-ed-root')
    ) {
      return section;
    }

    return section.querySelector
      ? section.querySelector('.sc-ed-root')
      : null;
  }

  function cleanup(root) {
    var state = instances.get(root);

    if (!state) return;

    if (state.observer) {
      state.observer.disconnect();
      state.observer = null;
    }

    if (state.timers && state.timers.length) {
      state.timers.forEach(function(timer) {
        clearTimeout(timer);
      });

      state.timers = [];
    }

    if (state.countdownInterval) {
      clearInterval(state.countdownInterval);
      state.countdownInterval = null;
    }

    instances.delete(root);
  }

  function activateAll(root, state) {
    var track = root.querySelector('[data-track-fill]');
    var stage2 = root.querySelector('[data-stage="2"]');
    var stage3 = root.querySelector('[data-stage="3"]');

    if (track) {
      track.style.transition = 'none';
      track.style.width = '100%';
    }

    if (stage2) {
      stage2.classList.add('is-active');
    }

    if (stage3) {
      stage3.classList.add('is-active');
    }

    state.animationStarted = true;
  }

  function runAnimation(root, state) {
    var track = root.querySelector('[data-track-fill]');
    var stage2 = root.querySelector('[data-stage="2"]');
    var stage3 = root.querySelector('[data-stage="3"]');

    if (!track || !stage2 || !stage3) {
      return;
    }

    var speed = Math.max(
      1,
      parseFloat(
        root.dataset.animationSpeed || '3'
      )
    );

    var delay = Math.max(
      0,
      parseFloat(
        root.dataset.animationDelay || '0'
      )
    );

    var halfDuration =
      (speed * 1000) / 2;

    /*
      IMPORTANT:
      First reset everything.
    */

    track.style.transition = 'none';
    track.style.width = '0%';

    stage2.classList.remove('is-active');
    stage3.classList.remove('is-active');

    /*
      Force the browser to actually paint
      the 0% state before starting.
    */

    void track.offsetWidth;

    var delayTimer = setTimeout(function() {

      /*
        PHASE 1
        Ordered → Dispatched
      */

      track.style.transition =
        'width ' +
        halfDuration +
        'ms cubic-bezier(.22,.61,.36,1)';

      requestAnimationFrame(function() {
        track.style.width = '50%';
      });

      var stage2Timer = setTimeout(function() {

        /*
          Dispatched becomes active
          exactly at the halfway point.
        */

        stage2.classList.add('is-active');

        /*
          PHASE 2
          Dispatched → Delivery
        */

        track.style.transition =
          'width ' +
          halfDuration +
          'ms cubic-bezier(.22,.61,.36,1)';

        requestAnimationFrame(function() {
          track.style.width = '100%';
        });

        var stage3Timer = setTimeout(function() {

          /*
            Delivery becomes active
            when the line reaches the end.
          */

          stage3.classList.add('is-active');

        }, halfDuration);

        state.timers.push(stage3Timer);

      }, halfDuration);

      state.timers.push(stage2Timer);

    }, delay);

    state.timers.push(delayTimer);
  }

  function startWhenVisible(root, state) {
    if (state.animationStarted) {
      return;
    }

    var timeline =
      root.querySelector('[data-timeline]');

    if (!timeline) {
      return;
    }

    var enabled =
      root.dataset.animationEnabled === 'true';

    if (!enabled) {
      activateAll(root, state);
      return;
    }

    /*
      Fallback for browsers without
      IntersectionObserver.
    */

    if (!('IntersectionObserver' in window)) {
      state.animationStarted = true;
      runAnimation(root, state);
      return;
    }

    state.observer =
      new IntersectionObserver(
        function(entries) {

          for (
            var i = 0;
            i < entries.length;
            i++
          ) {

            if (
              entries[i].isIntersecting &&
              !state.animationStarted
            ) {

              state.animationStarted = true;

              if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
              }

              runAnimation(root, state);

              break;
            }
          }

        },
        {
          threshold: 0.05,
          rootMargin: '0px 0px -10% 0px'
        }
      );

    state.observer.observe(root);
  }

  function setupCountdown(root, state) {

    if (
      root.dataset.countdownEnabled !== 'true'
    ) {
      return;
    }

    var output =
      root.querySelector('[data-countdown]');

    if (!output) {
      return;
    }

    var minutes = Math.max(
      1,
      parseInt(
        root.dataset.countdownMinutes || '10',
        10
      )
    );

    var storageKey =
      root.dataset.countdownKey;

    if (!storageKey) {
      return;
    }

    var endTime = null;

    try {

      var saved =
        window.sessionStorage.getItem(
          storageKey
        );

      if (saved) {

        var parsed =
          parseInt(saved, 10);

        if (parsed > Date.now()) {
          endTime = parsed;
        }
      }

    } catch (error) {
      endTime = null;
    }

    if (!endTime) {

      endTime =
        Date.now() +
        (
          minutes *
          60 *
          1000
        );

      try {

        window.sessionStorage.setItem(
          storageKey,
          String(endTime)
        );

      } catch (error) {}
    }

    var update = function() {

      var remaining =
        Math.max(
          0,
          endTime - Date.now()
        );

      var totalSeconds =
        Math.floor(
          remaining / 1000
        );

      var mins =
        Math.floor(
          totalSeconds / 60
        );

      var secs =
        totalSeconds % 60;

      output.textContent =
        String(mins).padStart(2, '0') +
        ':' +
        String(secs).padStart(2, '0');

      if (remaining <= 0) {

        clearInterval(
          state.countdownInterval
        );

        state.countdownInterval = null;
      }
    };

    update();

    state.countdownInterval =
      setInterval(
        update,
        1000
      );
  }

  function init(root) {

    if (
      !root ||
      instances.has(root)
    ) {
      return;
    }

    var state = {
      observer: null,
      countdownInterval: null,
      timers: [],
      animationStarted: false
    };

    instances.set(
      root,
      state
    );

    startWhenVisible(
      root,
      state
    );

    setupCountdown(
      root,
      state
    );
  }

  function initAll(scope) {

    var roots = [];

    if (scope) {

      var direct =
        getRoot(scope);

      if (direct) {
        roots.push(direct);
      }

      if (scope.querySelectorAll) {

        scope
          .querySelectorAll(
            '.sc-ed-root'
          )
          .forEach(
            function(root) {

              if (
                roots.indexOf(root) === -1
              ) {
                roots.push(root);
              }

            }
          );
      }

    } else {

      document
        .querySelectorAll(
          '.sc-ed-root'
        )
        .forEach(
          function(root) {
            roots.push(root);
          }
        );
    }

    roots.forEach(init);
  }

  function unloadSection(section) {

    if (!section) {
      return;
    }

    var root =
      getRoot(section);

    if (root) {
      cleanup(root);
    }
  }

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function() {
        initAll(document);
      }
    );

  } else {

    initAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function(event) {
      initAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function(event) {
      unloadSection(event.target);
    }
  );

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soracart-expected-delivery"] && !Shopify.designMode) return;
  try {
    
(function() {

  var instances = new WeakMap();

  function getRoot(section) {

    if (!section) {
      return null;
    }

    if (
      section.classList &&
      section.classList.contains('sc-ed-root')
    ) {
      return section;
    }

    return section.querySelector
      ? section.querySelector('.sc-ed-root')
      : null;
  }


  function cleanup(root) {

    var state = instances.get(root);

    if (!state) {
      return;
    }

    if (state.observer) {
      state.observer.disconnect();
      state.observer = null;
    }

    if (
      state.timers &&
      state.timers.length
    ) {
      state.timers.forEach(function(timer) {
        clearTimeout(timer);
      });

      state.timers = [];
    }

    if (state.countdownInterval) {
      clearInterval(state.countdownInterval);
      state.countdownInterval = null;
    }

    instances.delete(root);
  }


  function activateAll(root, state) {

    var track =
      root.querySelector('[data-track-fill]');

    var stage2 =
      root.querySelector('[data-stage="2"]');

    var stage3 =
      root.querySelector('[data-stage="3"]');

    var icon2 =
      root.querySelector('[data-icon-stage="2"]');

    var icon3 =
      root.querySelector('[data-icon-stage="3"]');


    if (track) {
      track.style.transition = 'none';
      track.style.width = '100%';
    }

    if (stage2) {
      stage2.classList.add('is-active');
    }

    if (stage3) {
      stage3.classList.add('is-active');
    }

    if (icon2) {
      icon2.classList.add('is-active');
    }

    if (icon3) {
      icon3.classList.add('is-active');
    }

    state.animationStarted = true;
  }


  function runAnimation(root, state) {

    var track =
      root.querySelector('[data-track-fill]');

    var stage2 =
      root.querySelector('[data-stage="2"]');

    var stage3 =
      root.querySelector('[data-stage="3"]');

    var icon2 =
      root.querySelector('[data-icon-stage="2"]');

    var icon3 =
      root.querySelector('[data-icon-stage="3"]');


    if (
      !track ||
      !stage2 ||
      !stage3
    ) {
      return;
    }


    var speed = Math.max(
      1,
      parseFloat(
        root.dataset.animationSpeed || '3'
      )
    );


    var delay = Math.max(
      0,
      parseFloat(
        root.dataset.animationDelay || '0'
      )
    );


    var halfDuration =
      (speed * 1000) / 2;


    track.style.transition = 'none';
    track.style.width = '0%';

    stage2.classList.remove('is-active');
    stage3.classList.remove('is-active');

    if (icon2) {
      icon2.classList.remove('is-active');
    }

    if (icon3) {
      icon3.classList.remove('is-active');
    }


    void track.offsetWidth;


    var delayTimer = setTimeout(function() {

      /*
        PHASE 1
        Ordered → Dispatched
      */

      track.style.transition =
        'width ' +
        halfDuration +
        'ms cubic-bezier(.22,.61,.36,1)';


      requestAnimationFrame(function() {

        track.style.width = '50%';

      });


      var stage2Timer =
        setTimeout(function() {

          stage2.classList.add(
            'is-active'
          );

          if (icon2) {
            icon2.classList.add(
              'is-active'
            );
          }


          /*
            PHASE 2
            Dispatched → Delivery
          */

          track.style.transition =
            'width ' +
            halfDuration +
            'ms cubic-bezier(.22,.61,.36,1)';


          requestAnimationFrame(function() {

            track.style.width = '100%';

          });


          var stage3Timer =
            setTimeout(function() {

              stage3.classList.add(
                'is-active'
              );

              if (icon3) {
                icon3.classList.add(
                  'is-active'
                );
              }

            }, halfDuration);


          state.timers.push(
            stage3Timer
          );

        }, halfDuration);


      state.timers.push(
        stage2Timer
      );

    }, delay);


    state.timers.push(
      delayTimer
    );
  }


  function setupAnimation(root, state) {

    if (state.animationStarted) {
      return;
    }


    var timeline =
      root.querySelector(
        '[data-timeline]'
      );


    if (!timeline) {
      return;
    }


    var enabled =
      root.dataset.animationEnabled ===
      'true';


    if (!enabled) {

      activateAll(
        root,
        state
      );

      return;
    }


    if (
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {

      activateAll(
        root,
        state
      );

      return;
    }


    if (
      !('IntersectionObserver' in window)
    ) {

      state.animationStarted = true;

      runAnimation(
        root,
        state
      );

      return;
    }


    state.observer =
      new IntersectionObserver(
        function(entries) {

          entries.forEach(
            function(entry) {

              if (
                entry.isIntersecting &&
                !state.animationStarted
              ) {

                state.animationStarted = true;

                state.observer.disconnect();

                state.observer = null;

                runAnimation(
                  root,
                  state
                );
              }

            }
          );

        },
        {
          threshold: 0.05,
          rootMargin:
            '0px 0px -10% 0px'
        }
      );


    state.observer.observe(
      timeline
    );
  }


  function setupCountdown(root, state) {

    if (
      root.dataset.countdownEnabled !==
      'true'
    ) {
      return;
    }


    var output =
      root.querySelector(
        '[data-countdown]'
      );


    if (!output) {
      return;
    }


    var minutes = Math.max(
      1,
      parseInt(
        root.dataset.countdownMinutes ||
        '10',
        10
      )
    );


    var storageKey =
      root.dataset.countdownKey;


    if (!storageKey) {
      return;
    }


    var endTime = null;


    try {

      var saved =
        window.sessionStorage.getItem(
          storageKey
        );


      if (saved) {

        var parsed =
          parseInt(
            saved,
            10
          );


        if (
          parsed > Date.now()
        ) {
          endTime = parsed;
        }

      }

    } catch (error) {

      endTime = null;

    }


    if (!endTime) {

      endTime =
        Date.now() +
        (
          minutes *
          60 *
          1000
        );


      try {

        window.sessionStorage.setItem(
          storageKey,
          String(endTime)
        );

      } catch (error) {}

    }


    var update =
      function() {

        var remaining =
          Math.max(
            0,
            endTime - Date.now()
          );


        var totalSeconds =
          Math.floor(
            remaining / 1000
          );


        var mins =
          Math.floor(
            totalSeconds / 60
          );


        var secs =
          totalSeconds % 60;


        output.textContent =
          String(mins).padStart(
            2,
            '0'
          ) +
          ':' +
          String(secs).padStart(
            2,
            '0'
          );


        if (
          remaining <= 0
        ) {

          clearInterval(
            state.countdownInterval
          );

          state.countdownInterval =
            null;
        }

      };


    update();


    state.countdownInterval =
      setInterval(
        update,
        1000
      );
  }


  function init(root) {

    if (
      !root ||
      instances.has(root)
    ) {
      return;
    }


    var state = {

      observer: null,

      countdownInterval: null,

      timers: [],

      animationStarted: false

    };


    instances.set(
      root,
      state
    );


    setupAnimation(
      root,
      state
    );


    setupCountdown(
      root,
      state
    );
  }


  function initAll(scope) {

    var roots = [];


    if (scope) {

      var direct =
        getRoot(scope);


      if (direct) {
        roots.push(direct);
      }


      if (
        scope.querySelectorAll
      ) {

        scope
          .querySelectorAll(
            '.sc-ed-root'
          )
          .forEach(
            function(root) {

              if (
                roots.indexOf(root) === -1
              ) {
                roots.push(root);
              }

            }
          );

      }

    } else {

      document
        .querySelectorAll(
          '.sc-ed-root'
        )
        .forEach(
          function(root) {

            roots.push(root);

          }
        );

    }


    roots.forEach(
      init
    );
  }


  function unloadSection(section) {

    if (!section) {
      return;
    }


    var root =
      getRoot(section);


    if (root) {
      cleanup(root);
    }
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function() {

        initAll(
          document
        );

      }
    );

  } else {

    initAll(
      document
    );

  }


  document.addEventListener(
    'shopify:section:load',
    function(event) {

      initAll(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function(event) {

      unloadSection(
        event.target
      );

    }
  );

})();

  } catch(e) { console.error(e); }
})();
})();
